const ManageUserSVG = () => (
  <svg
    width="22"
    height="17"
    viewBox="0 0 22 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="3.40426"
      cy="3.40426"
      r="3.40426"
      transform="matrix(-1 0 0 1 14.6172 1)"
      stroke="#8E8E8E"
      strokeWidth="1.5"
    />
    <path
      d="M5.25391 12.8594C5.25391 12.1272 5.71421 11.474 6.40377 11.2277V11.2277C9.51266 10.1174 12.91 10.1174 16.0189 11.2277V11.2277C16.7085 11.474 17.1688 12.1272 17.1688 12.8594V13.979C17.1688 14.9896 16.2737 15.7659 15.2733 15.6229L14.9398 15.5753C12.4667 15.222 9.956 15.222 7.48295 15.5753L7.1494 15.6229C6.14898 15.7659 5.25391 14.9896 5.25391 13.979V12.8594Z"
      stroke="#8E8E8E"
      strokeWidth="1.5"
    />
    <path
      d="M16.3213 7.90264C17.7986 7.90264 18.9961 6.70511 18.9961 5.22787C18.9961 3.75064 17.7986 2.5531 16.3213 2.5531"
      stroke="#8E8E8E"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M19.251 14.0051L19.5131 14.0425C20.2991 14.1548 21.0024 13.5448 21.0024 12.7508V11.8711C21.0024 11.2958 20.6407 10.7826 20.0989 10.5891C19.5585 10.3961 19.0069 10.2458 18.4492 10.1382"
      stroke="#8E8E8E"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M5.67868 7.90264C4.20144 7.90264 3.00391 6.70511 3.00391 5.22787C3.00391 3.75064 4.20144 2.5531 5.67868 2.5531"
      stroke="#8E8E8E"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M2.74898 14.0051L2.48691 14.0425C1.70086 14.1548 0.99759 13.5448 0.99759 12.7508V11.8711C0.99759 11.2958 1.35926 10.7826 1.90106 10.5891C2.4415 10.3961 2.99305 10.2458 3.55078 10.1382"
      stroke="#8E8E8E"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

const ManageUserSVGSelected = () => (
  <svg
    width="22"
    height="17"
    viewBox="0 0 22 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="3.40426"
      cy="3.40426"
      r="3.40426"
      transform="matrix(-1 0 0 1 14.6172 1)"
      stroke="#C44A25"
      strokeWidth="1.5"
    />
    <path
      d="M5.25391 12.8594C5.25391 12.1272 5.71421 11.474 6.40377 11.2277V11.2277C9.51266 10.1174 12.91 10.1174 16.0189 11.2277V11.2277C16.7085 11.474 17.1688 12.1272 17.1688 12.8594V13.979C17.1688 14.9896 16.2737 15.7659 15.2733 15.6229L14.9398 15.5753C12.4667 15.222 9.956 15.222 7.48295 15.5753L7.1494 15.6229C6.14898 15.7659 5.25391 14.9896 5.25391 13.979V12.8594Z"
      stroke="#C44A25"
      strokeWidth="1.5"
    />
    <path
      d="M16.3213 7.90264C17.7986 7.90264 18.9961 6.70511 18.9961 5.22787C18.9961 3.75064 17.7986 2.5531 16.3213 2.5531"
      stroke="#C44A25"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M19.251 14.0051L19.5131 14.0425C20.2991 14.1548 21.0024 13.5448 21.0024 12.7508V11.8711C21.0024 11.2958 20.6407 10.7826 20.0989 10.5891C19.5585 10.3961 19.0069 10.2458 18.4492 10.1382"
      stroke="#C44A25"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M5.67868 7.90264C4.20144 7.90264 3.00391 6.70511 3.00391 5.22787C3.00391 3.75064 4.20144 2.5531 5.67868 2.5531"
      stroke="#C44A25"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M2.74898 14.0051L2.48691 14.0425C1.70086 14.1548 0.99759 13.5448 0.99759 12.7508V11.8711C0.99759 11.2958 1.35926 10.7826 1.90106 10.5891C2.4415 10.3961 2.99305 10.2458 3.55078 10.1382"
      stroke="#C44A25"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

export { ManageUserSVG, ManageUserSVGSelected };
